
/**
 * Classe que gerencia o mapa
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 */


Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.Map = function (routeId) {

    this.startMap = function () {

        const centerMap = function () {
            return (typeof Monet.Session.sessionStorage.mapmain !== 'undefined' ) ? JSON.parse(Monet.Session.sessionStorage.mapmain) : {};
        }();

        if (!centerMap.center) {
            centerMap.center = { lat: -15.792254, lng: -48.001464 };
        }

        const map = Greenmile.Map.Utility.createDefaultMap(`routeMapContainer_${routeId}`);
        const baseLayer = Greenmile.Map.Utility.createBaseLayer();
        const screen = Monet.Session.RouteDetail.screensList[routeId];
        map.addLayer(baseLayer);

        map.routeId = routeId;
        map.elementContainer = 'routeMapContainer_' + routeId;

        const onZoom = (e) => {
          const equipmentList = screen.equipments;
          const actualPathLayerRoute = JSON.parse(
            Monet.Session.sessionStorage.getItem('layerMap')
          ).actual_route;

          const routeDetailState = GreenmileReduxStore.getState().routeDetails.toJS();
          const activeSources = routeDetailState.activeLayers;

          if (actualPathLayerRoute) {
            for (let equipmentId in equipmentList) {
              const equipment = equipmentList[equipmentId];
              const route = Monet.Session.RouteDetail.screensList[routeId].model;
              Greenmile.RouteDetail.Util.renderPathFromPositionSources(
                equipment,
                route,
                equipmentList[equipmentId].positionSources,
                activeSources?.[routeId]
              );
            }
          }
        }
        let timer;
        const schedule = () => {
          cancelAnimationFrame(timer);
          timer = requestAnimationFrame(onZoom);
        };

        map.on('moveend', schedule);

        Monet.Session.RouteDetail.screensList[routeId].map = map;
        Monet.Session.RouteDetail.screensList[routeId].mapBaseLayer = baseLayer;

        return map;

    };

    this.focusOnTheEvent = eventId => {
      const { map, shouldOpenPopup} = Monet.Session.RouteDetail.screensList[routeId];

      for (const key in map._layers) {
        const layer = map._layers[key];
        const routeMapsId = `routeMaps_${routeId}_${eventId}`;
        const routeDetailsId = `RouteDetails_${routeId}_${eventId}`;
        if (layer.kind  === 'EVENT' && (String(layer.id) === routeMapsId || String(layer.id) === routeDetailsId) && shouldOpenPopup) {
            layer.openPopup();
            Monet.Session.RouteDetail.screensList[routeId].shouldOpenPopup = false;
        }
      }

    };

    this.focusOnTheStop = function (stop) {

        var screenList = Monet.Session.RouteDetail.screensList[routeId];
        var map = screenList.map;

        if (screenList.timeoutLayerFocus) {
            screenList.timeoutLayerFocus = [];
        }

        var lat = stop.latitude || (stop.location && stop.location.latitude);
        var lng = stop.longitude || (stop.location && stop.location.longitude);

        var markerFocusIcon = null;

        var clearAllTimeout = function () {

            var timeOuts = screenList.timeoutLayerFocus;

            for (var key in timeOuts) {

                clearTimeout(timeOuts[key]);
                timeOuts.splice(key, 1);

            }

            screenList.timeoutLayerFocus = timeOuts;

        };

        var dismissFocus = function () {

          if(screenList.layerFocus && screenList.layerFocus._leaflet_id) {
            map.removeLayer(screenList.layerFocus);
          }
          clearAllTimeout();

        };

        if (screenList.layerFocus && screenList.layerFocus._leaflet_id) {
            dismissFocus();
        }

        markerFocusIcon = L.divIcon({
            className: "markerDetailRoute",
            html: '<div class="greenmileMarkerFocusIcon"></div>',
            iconSize: [50, 50]
        });

        if (lat && lng) {
            let markerFocus = new L.marker(
                [lat, lng], {
                    icon: markerFocusIcon,
                    zIndexOffset: -1
                });

            markerFocus.addTo(map);
            map.setView([lat, lng], map.getMaxZoom());
            screenList.layerFocus = markerFocus;
        }

        if (screenList.timeoutLayerFocus.length > 0) {
            clearAllTimeout();
        }

        var timeout = setTimeout(function () {
            dismissFocus();
        }, 8000);

        screenList.timeoutLayerFocus.push(timeout);

    };

};
